import request from '@/api/request'
// 获取公司下拉列表数据
export const getPlatform = (data) => {
  return request({
    url: '/v1/manager/user/device/platform/list',
    method: 'post',
    data: data
  })
}
// 获取设备表格列表
export const getPlatformTable = (data) => {
  return request({
    url: '/v1/manager/user/device/list',
    method: 'post',
    data: data
  })
}
// 获取设备总数
export const getProductionList = (data) => {
  return request({
    url: '/v1/manager/user/device/platform/count',
    method: 'post',
    data: data
  })
}
// 统计在线离线
export const statistics_product = (data) => {
  return request({
    url: '/v1/manager/user/device/mqtt/productId_statistics',
    method: 'post',
    data: data
  })
}

// 获取设备详情列表
export const getEqInformation = (data) => {
  return request({
    url: '/v1/manager/user/device/info',
    method: 'post',
    data: data
  })
}
// 获取指定设备属性状态
export const getEqByPlatformId = (data) => {
  return request({
    url: '/v1/manager/user/device/status',
    method: 'post',
    data: data
  })
}
// 获取设备流日志
export const getStreamLog = (data) => {
  return request({
    url: '/v1/manager/user/device/stream/logcat',
    method: 'post',
    data: data
  })
}
// 获取HTTP日志
export const getHTTPLog = (data) => {
  return request({
    url: '/v1/manager/user/device/client/logcat',
    method: 'post',
    data: data
  })
}
// 获取指定设备请求日志
export const getRequestLog = (data) => {
  return request({
    url: '/v1/manager/user/device/mqtt/logcat/',
    method: 'post',
    data: data
  })
}
// 获取设备日志缩略图
export const getLogImg = (data) => {
  return request({
    url: '/v1/manager/user/device/mqtt/logcat/logcat_img',
    method: 'post',
    data: data
  })
}
/**
 *
 * @param {*} data
 * @returns
 */
// 添加物模型-属性
export const addModelList = (data) => {
  return request({
    url: '/v1/manager/user/product/add/properties',
    method: 'post',
    data: data
  })
}
// 添加物模型-属性
export const getModelList = (data) => {
  return request({
    url: '/v1/manager/user/product/properties/list',
    method: 'post',
    data: data
  })
}
// 根据id删除单个物模型-属性
export const deleteModelByDocId = (data) => {
  return request({
    url: '/v1/manager/user/product/delete/docId',
    method: 'post',
    data: data
  })
}
// 获取事件表格信息
export const getEventList = (data) => {
  return request({
    url: '/v1/manager/user/product/events/list',
    method: 'post',
    data: data
  })
}
// 事件表单添加信息
export const addEventLists = (data) => {
  return request({
    url: '/v1/manager/user/product/add/events',
    method: 'post',
    data: data
  })
}
// 获取物模型源数据
export const getEventDataO = (data) => {
  return request({
    url: '/v1/manager/user/product/get/docId',
    method: 'post',
    data: data
  })
}
// 查看产品信息
export const getProductListInfoById = (data) => {
  return request({
    url: '/v1/manager/user/product/info',
    method: 'post',
    data: data
  })
}
// 添加物模型行为
export const addActiveList = (data) => {
  return request({
    url: '/v1/manager/user/product/add/actions',
    method: 'post',
    data: data
  })
}
// 获取行为表格数据
export const getActiveList = (data) => {
  return request({
    url: '/v1/manager/user/product/actions/list',
    method: 'post',
    data: data
  })
}

//获取运行状态属性详情
export const getEsList = (data) => {
  return request({
    url: '/v1/manager/user/device/ota/getEsList',
    method: 'post',
    data: data
  })
}

//  产品属性复制
export const getProperties = (data) => {
  return request({
    url: '/v1/manager/user/product/copy/properties',
    method: 'post',
    data: data
  })
}

// 产品行为复制
export const getAction = (data) => {
  return request({
    url: '/v1/manager/user/product/copy/action',
    method: 'post',
    data: data
  })
}

// 产品事件复制
export const getEvents = (data) => {
  return request({
    url: '/v1/manager/user/product/copy/events',
    method: 'post',
    data: data
  })
}

// 更新Http服务字段
export const getHttp_service = (data) => {
  return request({
    url: '/v1/manager/user/product/update/http_service',
    method: 'post',
    data: data
  })
}

// 拷贝单个物模型
export const copyModel = (data) => {
  return request({
    url: '/v1/manager/user/product/copy/product-model',
    method: 'post',
    data: data
  })
}
